import React, { useState, useEffect } from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import TextField from '@material-ui/core/TextField';

import axios from "axios";
import { Auth } from 'aws-amplify';
import * as env from "../../environment";
const { API_URL_BACKEND_ECS } = env[process.env.NODE_ENV];

const fechaFormatNoTime = (laFechaString) => {
  const laFecha = new Date(laFechaString)
  const diaTmp = laFecha.getDate()
  const dia = diaTmp < 10 ? '0' + diaTmp : diaTmp
  const mesTmp = laFecha.getMonth() * 1 + 1
  const mes = mesTmp < 10 ? '0' + mesTmp : mesTmp

  return dia + '-' + mes + '-' + laFecha.getFullYear()
}

const fechaFormat = (laFechaString) => {
  const laFecha = new Date(laFechaString)
  const diaTmp = laFecha.getDate()
  const dia = diaTmp < 10 ? '0' + diaTmp : diaTmp
  const mesTmp = laFecha.getMonth() * 1 + 1
  const mes = mesTmp < 10 ? '0' + mesTmp : mesTmp
  const horaTmp = laFecha.getHours()
  const hora = horaTmp < 10 ? '0' + horaTmp : horaTmp
  const minutoTmp = laFecha.getMinutes()
  const minuto = minutoTmp < 10 ? '0' + minutoTmp : minutoTmp

  return dia + '-' + mes + '-' + laFecha.getFullYear() + ' ' + hora + ':' + minuto
}

const ExcelExportAsync = ({ elPeriodo, fileName, correo }) => {

  const [periodoId, setPeriodoId] = useState(0)
  const [loading, setLoading] = useState(false)
  const [elCorreo, setElCorreo] = useState('')
  const [mensaje, setMensaje] = useState('')

  useEffect(() => {
    console.log("Nuevo periodo en excel: ", elPeriodo)
    setPeriodoId(elPeriodo)
  }, [elPeriodo]);

  const refreshToken = async () => {
    try {
        const session = await Auth.currentSession();
        console.log("session", session)
        console.log("access token", session.accessToken.jwtToken)
        localStorage.setItem("token", session.accessToken.jwtToken);
    } catch (e) {
      localStorage.clear();
      window.location = '/';
    }
  };

  const obtieneReporteAsync = async () => {
    if (periodoId > 0) {
        console.log("refrescamos el token")
        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            },
            timeout: 60 * 1000 * 60 //1 hora timeout
        };
        
        const endpoint = `${API_URL_BACKEND_ECS}/report/despachodigital/${periodoId}`

        console.log("Llamando al endpoint [" + endpoint + "] con el config [" + config + "]")

        try {
            const response = await axios.post(endpoint, {correo : elCorreo}, config)
          
              if (response.status === 200) {
                console.log("Respuesta", response.data)
            } else {
                alert("error " + response.status + " : " + response.message)
            }
          } catch(error) {
            console.log("Error al consultar endpoint", error)
          }

    } else {
        alert("No hay periodo especificado")
    }
  }

  const obtieneReporte = async () => {
    //Si periodoId > 0, busco el reporte
    if (periodoId > 0) {

      console.log("refrescamos el token")
        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            },
            timeout: 60 * 1000 * 60 //1 hora timeout
        };
        
        const endpoint = `${API_URL_BACKEND_ECS}/report/despachodigital/${periodoId}`

        console.log("Llamando al endpoint [" + endpoint + "] con el config [" + config + "]")

        setLoading(true)

        let excel = []
        try {
          const response = await axios.get(endpoint, config)
        
            if (response.status === 200) {
                console.log("Respuesta", response.data)

                
                response.data.data.forEach((registro, index) => {
                    excel.push({
                        id: registro.id,
                        mes: registro.periodo.mes,
                        año: registro.periodo.anio,
                        correo: registro.correo,
                        cliente: registro.cliente,
                        cuenta: registro.cuenta,
                        folio: registro.folio,
                        'numero documento': registro.nro_doc,
                        'fecha de emisión': registro.fecha_emision_doc ? fechaFormatNoTime(registro.fecha_emision_doc) : '',
                        'fecha de distribución': registro.fecha_distribucion ? fechaFormat(registro.fecha_distribucion) : '',
                        estado: registro.estado,
                        'fecha estado': registro.fecha_estado ? fechaFormat(registro.fecha_estado) : '',
                        inserto: registro.posee_inserto ? "SI" : "NO",
                        'anexo netbilling': registro.posee_anx_netbilling ? "SI" : "NO",
                        'anexo mal factor potencia': registro.posee_anx_carta_mfp ? "SI" : "NO",
                        'unidad lectura': registro.unidad_lectura,
                        programa: registro.programa,
                        'tipo de rebote': registro.rebote_tipo,
                        'subtipo de rebote': registro.rebote_subtipo,
                        'diagnostico': registro.diagnostico
                    });
                });
            } else {
                alert("error " + response.status + " : " + response.message)
            }
          } catch(error) {
            console.log("Error al consultar endpoint", error)
          }
          setLoading(false)
        return excel
    } else {
      console.log("No hay periodo especificado")
    }
}

  const exportToExcel = async () => {
    if(elCorreo.trim() !== ""){
        setMensaje("El reporte sera enviado a su casilla de correo")
        await obtieneReporteAsync()
    } else {
        setMensaje("Generando...")
        const data = await obtieneReporte()
        console.log("La data a exportar: ", data )
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        setMensaje("")
        saveAs(blob, `${fileName}.xlsx`);
    }
    
  };

  return (
    <>
    <div class="loader-box">
        <TextField placeholder=""
                                                type="text"
                                                label="Correo"
                                                inputProps={{ maxLength: 50 }}
                                                value={elCorreo}
                                                onChange={(ev) => {
                                                    setElCorreo(ev.target.value );
                                                }}
                                            />
      <button onClick={exportToExcel} disabled={loading}>Exportar a Excel </button>{loading && <div class="loader"></div>}
    </div>
    <p>{mensaje}</p>
    </>
  );
}

export default ExcelExportAsync;